import * as React from "react";
import { Route, RouteProps } from "react-router-dom";

import Authorized from "components/Authorized";
import { AuthorizedProps } from "components/Authorized/Authorized";

interface AuthorizedRouteProps extends RouteProps, AuthorizedProps {}

const AuthorizedRoute: React.FC<AuthorizedRouteProps> = (props) => {
  return (
    <Authorized
      usesPermissions={props.usesPermissions}
      permissionsToView={props.permissionsToView}
    >
      <Route {...props} />
    </Authorized>
  );
};

export default AuthorizedRoute;
